<template>
    <div>
        <span class="el-style attribute-name">Message:</span>
        <div class="message message-body" v-text="message"></div>
    </div>
</template>

<script>
  export default {
    props: {
      row: Object,
    },

    data() {
      return {
        //
      };
    },

    computed: {
      message() {
        return _.get(this.row, 'model.message', null) || '';
      },
    },

    methods: {
      //
    }
  }
</script>

